import { ObjectMapper } from 'json-object-mapper';
import { Model, OptionModel } from '../model';
import { IModel } from '../IModel';
import { SalaryRangeModel } from './salaryRange.model';

export class SalaryScaleModel extends Model implements IModel<SalaryScaleModel> {
  title: string = '';
  foreingId: string = '';
  description: string = '';
  minimum: number = 0;
  medium: number = 0;
  maximum: number = 0;
  referenceDate: string = '';
  salaryRanges: SalaryRangeModel[] = [];
  
  static create(input: any): SalaryScaleModel {
    return ObjectMapper.deserialize<SalaryScaleModel>(SalaryScaleModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  toOption(): OptionModel {
    return { 
      label: `${this.title} - ${this.description} (R$ ${this.minimum.toLocaleString('pt-BR')} - R$ ${this.maximum.toLocaleString('pt-BR')})`, 
      value: this.id 
    } as OptionModel;
  }
}
